import { KeyboardEvent, ReactElement } from 'react';
import * as SC from './styles';
import classic from '../../../../styles/theme/classic';
import { Size } from '../../../../styles/theme/types';
import TypeChecker from '../../../../helpers/classes/TypeChecker';

interface ButtonProps {
  className?: string;
  color: string;
  buttonSize?: Size;
  icon: ReactElement;
  onClick?: CallbackFunction;
  disabled?: boolean;
  rotateIcon?: number;
  iconSize?: Size;
  iconColor?: string;
  shadow?: string;
}

export default function IconButton({
  className = '',
  color,
  buttonSize = { width: '47px', height: '47px' },
  icon,
  onClick,
  disabled = false,
  rotateIcon,
  iconSize = { width: '20px', height: '20px' },
  iconColor = classic.palette.main.marine,
  shadow = '0 4px 4px rgba(0, 0, 0, 0.25)',
  ...props
}: ButtonProps) {
  const clickable = TypeChecker.isFunction(onClick) && !disabled;

  const handleKeyDown = (e: KeyboardEvent<HTMLDivElement>) => {
    if (
      (e.key === ' ' || e.key === 'Enter' || e.key === 'Spacebar') &&
      clickable
    ) {
      e.preventDefault();
      onClick?.();
    }
  };

  return (
    <SC.Container
      className={className}
      color={color}
      width={buttonSize.width}
      height={buttonSize.height}
      disabled={disabled}
      clickable={clickable}
      shadow={shadow}
      role="button"
      aria-pressed="false"
      tabIndex={0}
      onClick={clickable ? onClick : undefined}
      onKeyDown={handleKeyDown}
      {...props}
    >
      <SC.IconContainer
        disabled={disabled}
        clickable={clickable}
        rotateIcon={rotateIcon}
        width={iconSize.width}
        height={iconSize.height}
        color={iconColor}
      >
        {icon}
      </SC.IconContainer>
    </SC.Container>
  );
}
